import { render, staticRenderFns } from "./SubmissionFormContactInfo.vue?vue&type=template&id=268a2097&scoped=true&"
import script from "./SubmissionFormContactInfo.vue?vue&type=script&lang=ts&"
export * from "./SubmissionFormContactInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268a2097",
  null
  
)

export default component.exports